import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsCreatedSurveyNoList from "../created-list-inner-pages/tms-sm-ral-survey-creation-list";
import TmsSurveyNoCreation from "../creation-inner-pages/tms-survey-no-creation";
const LandSurveyNoIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Survey No Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsCreatedSurveyNoList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Survey No Creation"}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsSurveyNoCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LandSurveyNoIndex;
